import React from 'react';
import Slideartical from '../swiper/sliderartical';


export default function ({ feedItem, eleRef }) {
    return ( 
 
 <div  className="main_block_container_feed hArticle">
                        <div className="block_container_feed_heading_text second-art R15_61 articleTitle">
                        {(feedItem.title)?feedItem.title:''}
                        </div>
                        <div className="content-div_view_artical box-circle-artical">
                            <Slideartical page={"dr-carousel-unit"} data={feedItem}  />
                        </div>
                     
                    </div>

                    )
                }
